import * as LabelPrimitive from "@radix-ui/react-label";
import { cn } from "../lib/utils";
import { cva } from "class-variance-authority";
import * as React from "react";
const labelVariants = cva(cn("s-heading-sm", "peer-disabled:s-cursor-not-allowed peer-disabled:s-opacity-70"), {
    variants: {
        variant: {
            default: cn("s-text-foreground", "dark:s-text-foreground-night"),
            muted: cn("s-text-muted-foreground", "dark:s-text-muted-foreground-night"),
        },
    },
    defaultVariants: {
        variant: "default",
    },
});
const Label = React.forwardRef(({ className, variant, isMuted = false, ...props }, ref) => {
    const effectiveVariant = isMuted ? "muted" : variant;
    return (React.createElement(LabelPrimitive.Root, { ref: ref, className: cn(labelVariants({ variant: effectiveVariant }), className), ...props }));
});
Label.displayName = LabelPrimitive.Root.displayName;
export { Label, labelVariants };
//# sourceMappingURL=Label.js.map